import { getBrowserLocale } from 'i18n/helpers';

export interface SrcDocParams {
  cssReset: string;
  chatIconAlign: string;
  coreSrc: string;
  widgetSrc: string;
  apiKey: string;
  shop?: string;
  nonce?: string;
}

function h<K extends keyof HTMLElementTagNameMap>(
  tagName: K,
  attributes?: Record<string, string> | null,
  ...children: (Element | string)[]
) {
  const element = document.createElement(tagName);
  if (attributes) {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const key in attributes) {
      element.setAttribute(key, attributes[key]);
    }
  }
  for (let i = 0; i < children.length; i += 1) {
    let child: string | Node = children[i];
    if (typeof child === 'string') {
      child = document.createTextNode(child);
    }
    element.appendChild(child);
  }
  return element;
}

export function buildSrcdoc({
  cssReset,
  chatIconAlign,
  coreSrc,
  widgetSrc,
  apiKey,
  shop,
  nonce,
}: SrcDocParams) {
  let className = `align-chat-icon-${chatIconAlign}`;
  if (shop && shop.length > 0) {
    className += ' shop';
  }
  const childDoc = h(
    'html',
    { lang: getBrowserLocale() },
    h('head', null, h('style', null, cssReset)),
    h(
      'body',
      {
        class: className,
      },
      h('div', {
        id: 'root',
      }),
      h('base', {
        target: '_parent',
      }),
      h('script', {
        src: coreSrc,
        'data-kustomer-api-key': apiKey,
        ...(nonce && { nonce }),
      }),
      h('script', {
        async: 'true',
        src: widgetSrc,
        ...(nonce && { nonce }),
      }),
    ),
  );

  return `<!DOCTYPE html>${childDoc.outerHTML}`;
}
